import * as actionTypes from "./../../Constants/categoryActionTypes";
import * as actions from './notification';

export const categories = () => ({
    type: actionTypes.RESET_ALL_CATEGORIES,
})

export function resetAllCategories () {
    return dispatch => {
        // dispatch(actions.notify("Reset Successfull","bottom"));
        return dispatch(categories());
    };
}
